














































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import api from "@/getinfo-api";
import UsersActionAdmin from "@/components/courses/UsersActionAdmin.vue";
import { AxiosError } from "axios";
import { Course as ICourse } from "@/api/models/course";
import { CourseEdit as ICourseEdit } from "@/api/models/course-edit";
import { CourseLecture as ICourseLecture } from "@/api/models/course-lecture";
import { CourseLectureShortList as ICourseLectureShortList } from "@/api/models/course-lecture-short-list";
import { CourseLectureProgress as ICourseLectureProgress } from "@/api/models/course-lecture-progress";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import AssignTestToEntity from "@/components/tests/AssignTestToEntity.vue";
import { getCurrentCompanyId, getCurrentUserId, isRoot } from "@/plugins/roles";
import {
  CourseProgress as ICourseProgress,
  CourseProgressStatusEnum
} from "@/api/models/course-progress";
import { CourseTestPassProgress as ICourseTestPassProgress } from "@/api/models/course-test-pass-progress";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api/models/course-document-info";
import AttachLectureToCourse from "@/components/lectures/AttachLectureToCourse.vue";
import Modal from "@/components/form/Modal.vue";
import { learningDocumentsModule } from "@/plugins/modules-detect";
import CourseLectureTree from "@/components/courses/CourseLectureTree.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";

@Component({
  components: {
    EntityFiles,
    CBlock,
    TextField,
    CBreadCrumbs,
    CourseLectureTree,
    AssignTestToEntity,
    UsersActionAdmin,
    Modal,
    AttachLectureToCourse
  }
})
export default class CourseView extends Vue {
  courseInfo!: ICourse;
  courseLecturesList!: ICourseLectureShortList;
  showTestSettings: boolean = false;
  lecturesProgress: Array<ICourseLectureProgress> | undefined = [];
  progress!: ICourseProgress;
  currentListenerId!: string;
  canRender: boolean = false;
  qualification!: any;
  programTitle!: any;
  specialtyTitle!: any;
  activityTitle!: any;
  docType!: any;
  validityOfDocument!: number | any;
  isLoadingFiles: boolean = false;
  isLecturesLoading: boolean = false;

  data() {
    return {
      docType: undefined,
      validityOfDocument: undefined,
      courseInfo: undefined,
      courseLecturesList: undefined,
      practiceInfo: undefined,
      progress: undefined,
      currentListenerId: undefined,
      qualification: undefined,
      programTitle: undefined,
      specialtyTitle: undefined,
      activityTitle: undefined
    };
  }

  scrollTo() {
    if (!this.showTestSettings) {
      this.showTestSettings = true;
      window.scrollTo({
        top: 650,
        behavior: "smooth"
      });
    } else {
      this.showTestSettings = false;
    }
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: ICourseEdit = {
      fileIds:
        this.courseInfo.files && fromDocTemplate
          ? [...this.courseInfo.files.map((el: any) => el.id), ...files]
          : [...files]
    };

    this.isLoadingFiles = true;

    api.CourseApi.edit(this.courseInfo.id, params)
      .then((res: { data: ICourse }) => {
        this.courseInfo = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  getCourseDocumentInfo() {
    api.CourseApi.getDocumentInfo(this.$route.params.courseId)
      .then((res: { data: ICourseDocumentInfo }) => {
        if (res.data) {
          this.qualification = res.data?.qualification;
          this.programTitle = res.data.program?.title;
          this.specialtyTitle = res.data.specialty?.title;
          this.activityTitle = res.data.activity?.title;
          this.validityOfDocument = res.data.validityOfDocument;
          this.docType = res.data.documentType?.title;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$t(this.$translate.Courses)
      },
      {
        label: this.$converter.limitedOutput(this.courseInfo.title, 40)
      }
    ];
  }

  get firstPassedTest() {
    const findFirstPassedTest = (el: ICourseTestPassProgress) => {
      return el.success;
    };

    return this.progress
      ? this.progress.test?.pass.find(findFirstPassedTest)
      : undefined;
  }

  get testSuccess() {
    return this.progress ? this.progress.test?.success : false;
  }

  get status() {
    return CourseProgressStatusEnum;
  }

  get isHasAccessToIntermediateTest() {
    const checkByProgress = this.progress?.status === this.status.Learning;
    return (
      this.testId &&
      this.courseInfo?.test?.intermediateTest &&
      this.courseInfo.test.enabled &&
      this.canRender &&
      checkByProgress
    );
  }

  get practiceSuccess() {
    return !!this.progress?.practice?.passedAt;
  }

  get testId() {
    return this.courseInfo && this.courseInfo.test
      ? this.courseInfo.test.id
      : undefined;
  }

  get formattedFreeNavigation() {
    return this.courseInfo.freeNavigation
      ? `${this.$tc(this.$translate.Yes)}`
      : `${this.$tc(this.$translate.Not)}`;
  }

  get userCanEditCourse() {
    return this.root || this.companyOwner || this.courseOwner;
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.userId === this.courseInfo?.company?.owner.id;
  }

  get courseOwner() {
    return this.userId === this.courseInfo?.owner?.id;
  }

  get navigation() {
    return this.courseInfo?.freeNavigation;
  }

  get company() {
    return getCurrentCompanyId();
  }

  async getProgressByListener() {
    let listenerIdByCourse = await api.CourseApi.listenerGetActiveByUser(
      this.courseInfo.id,
      this.userId
    );

    try {
      if (listenerIdByCourse.data) {
        const listenerId = listenerIdByCourse.data.id;
        this.currentListenerId = listenerId;

        const listenerProgressResponse = await api.CourseApi.listenerProgress(
          this.courseInfo.id,
          listenerId
        );
        this.lecturesProgress = listenerProgressResponse.data.lectures;
        this.progress = listenerProgressResponse.data;
      }
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.canRender = true;
    }
  }

  get lecturesIdsInCourse() {
    return this.courseLecturesList?.lectures?.length
      ? this.courseLecturesList?.lectures?.map(el => el.lecture?.id)
      : undefined;
  }

  getCourse() {
    this.showTestSettings = false;
    api.CourseApi.get(this.$route.params.courseId)
      .then((res: { data: ICourse }) => {
        this.courseInfo = res.data;
        document.title = this.courseInfo?.title;

        this.getProgressByListener();
        this.renderLectureList();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get isDocumentBundle() {
    return learningDocumentsModule();
  }

  get currentTaxonomy() {
    return (
      (this.qualification && this.qualification.length) ||
      (this.activityTitle && this.activityTitle.length) ||
      (this.programTitle && this.programTitle.length) ||
      (this.specialtyTitle && this.specialtyTitle.length)
    );
  }

  renderLectureList() {
    this.isLecturesLoading = true;
    api.CourseLectureApi.listShort(this.courseInfo.id)
      .then((response: { data: ICourseLectureShortList }) => {
        this.courseLecturesList = response.data;
      })
      .finally(() => {
        this.isLecturesLoading = false;
      });
  }

  deleteCourseLecture(item: ICourseLecture) {
    api.CourseLectureApi._delete(this.courseInfo.id, item.id)
      .then(() => {
        this.$store.dispatch("successToast", {
          message: `${this.$tc(this.$translate.Success)}`
        });
        this.renderLectureList();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    setTimeout(() => {
      if (this.userCanEditCourse && this.isDocumentBundle) {
        this.getCourseDocumentInfo();
      }
    }, 4000);
    this.getCourse();
  }
}
